<template>
  <div>
    <a :class="selectedInvoicePath ? 'selected' : 'not-selected'" @click="selectInvoicePath">{{ $t('nav.invoices') }}</a>
    <a :class="selectedTerminalPath ? 'selected': 'not-selected'" @click="selectTerminalPath">{{ $t('nav.terminals') }}</a>
    <a :class="selectedTransfersPath ? 'selected' : 'not-selected'" @click="selectTransfersPath">{{ $t('nav.transfers') }}</a>
  </div>
</template>

<script>
export default {
name: 'ClubNavbar',
  computed: {
    selectedInvoicePath() {
      return this.$route.path.includes('invoice');
    },
    selectedTerminalPath() {
      return this.$route.path.includes('terminal');
    },
    selectedTransfersPath() {
      return this.$route.path === '/club/transfers';
    }
  },
  methods: {
    selectInvoicePath() {
      this.$router.push('/club/invoice/list');
    },
    selectTerminalPath() {
      this.$router.push('/club/terminal/list');
    },
    selectTransfersPath() {
      this.$router.push('/club/transfers');
    }
  },
}
</script>

<style scoped>
div {
  color: #000;
  outline: 0;
  vertical-align: baseline;
  font-style: normal;
  overflow: hidden;
  padding-top: 15px;
  text-transform: lowercase;
  font-family: Verdana, sans-serif;
  text-align: left;
  font-size: 24px;
}

.not-selected {
  text-transform: lowercase;
  font-family: Verdana, sans-serif;
  font-size: 24px;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
  outline: 0;
  font-style: normal;
  color: #6690c9;
  float: left;
  display: block;
  margin-right: 24px;
}

.not-selected:hover {
  display: block;
  float: left;
  color: #369;
  margin-right: 24px;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-style: normal;
  outline: 0;
  cursor: pointer;
  text-decoration: underline;
  text-align: left;
  font-family: Verdana, sans-serif;
  text-transform: lowercase;
}

.selected {
  text-transform: lowercase;
  font-family: Verdana, sans-serif;
  font-size: 24px;
  text-align: left;
  cursor: pointer;
  outline: 0;
  font-style: normal;
  border: 0;
  padding: 0;
  float: left;
  display: block;
  margin-right: 24px;
  color: #000;
  text-decoration: none;
}
</style>
